<template>
  <el-button :size="btnSize"
             :type="btnType"
             :disabled="btnDisabled">确 定</el-button>
</template>

<script>

export default {
  props: ['btn-disabled', 'btn-size', 'btn-type']
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/common/Submitting.vue